function QuestItem(item){

  return <div className="questItem">{item}</div>
}

export default QuestItem;